import React, { useRef, useState } from "react";
// import { Link } from 'react-router-dom'
// import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyVoterID = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);
    const [voter, setVoter] = useState({
        number: selectedStaff?.staffDetails?.staff_bg_verification?.voter_id_number,
        status: selectedStaff?.staffDetails?.staff_bg_verification?.voter_id_verification_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.voter_id_file,
    });
    const [voter1, setVoter1] = useState({
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.voter_id_file,
    });


    async function submitVoterID() {

        // if (!voter?.number || !voter?.veriicationFile) {
        //     openToast("Provide either voter id number or upload file", "warning");
        //     return;
        // }

        setIsLoading(true);
        const newFormData = new FormData();
        newFormData.append("voter_id_number", voter?.number);
        newFormData.append("verificationFile", voter?.verificationFile);

        try {
            const response = await fetch(baseUrl + "bg-verification/" + selectedStaff.staffDetails.id + "/verify/voter_id", {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                },
                body: newFormData
            });

            console.log(response);

            if (response.status === 201) {
                const result = await response.json();
                console.log(result);
                setVoter({ ...voter, number: result?.data?.voter_id_number, status: result?.data?.voter_id_verification_status, veriicationFile: result?.data?.voter_id_file });
                openToast("Voter ID successfully updated or created", "success");
                closeModal2();
            } else {
                openToast("An error occurred while adding or updating Voter ID", "error");
            }
        } catch (error) {
            console.error("Error submitting Aadhaar:", error);
            openToast("An error occurred while adding or updating Voter ID", "error");
        }
        finally {
            setIsLoading(false);
        }
    }



    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const fileInputRef = useRef(null);

    // Function to handle button click and open file input dialog
    const handleUploadClick = () => {
        fileInputRef.current.click(); // Trigger click on input type="file"
    };

    // Function to handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setVoter({ ...voter, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setVoter1({ ...voter, verificationFile: fileURL }); // Update state with the file URL
        }
    };

    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium'>Voter ID Verification</h3>
                <button className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed animate-pulse')} onClick={submitVoterID}>
                    Update Voter ID
                </button>
            </div>

            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Voter ID</h4>
                <p className='font-light'>{voter?.number}</p>
                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{voter?.status}</p>
            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }} // Hide the input element
                />
                <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {voter1?.verificationFile ? (
                        typeof voter1.verificationFile === "string" ? (
                            <img
                                src={voter1.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>
                <button className='second-btn' onClick={handleUploadClick}>
                    Upload
                </button>

            </div>


            <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"

            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add Voter ID</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]'>Voter ID
                        </label><br />
                        <input type='text' placeholder="0000-0000-0000" className='border-1 newsetup3 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={voter?.number} onChange={(e) => setVoter({ ...voter, number: e.target.value })} /><br />


                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn' onClick={closeModal2} >Save </button>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default VerifyVoterID